import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum SignInEnum {
  未签到 = 0,
  已签到 = 1,
  过期未签到 = 2,
}

// 男用户激励任务页 (http://wiki.xunlei.cn/pages/viewpage.action?pageId=145480754)
export const maleReward = createAsyncThunk(
  'Saada/live/saada/fetch_m_rd_page',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/saada/fetch_m_rd_page',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)

// 每日签到 http://wiki.xunlei.cn/pages/viewpage.action?pageId=145480801
export const signIn = createAsyncThunk(
  'Saada/live/saada/m_rd_page_signin',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/saada/m_rd_page_signin',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data.data
  }
)

// 通知提醒开关 http://wiki.xunlei.cn/pages/viewpage.action?pageId=179499776
export const common_switch = createAsyncThunk(
  'Saada/manPower/live/hiya_socialize/common_switch',
  async (p: any, store: any) => {
    const resp = await http.post('/live/hiya_socialize/common_switch', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

export enum rewardType {
  聊天卡片 = 1,
  金币 = 2,
  聊天气泡 = 3,
}

export interface sign_reward {
  signin_day: number
  reward_type: rewardType
  reward_cnt: number
  reward_icon: string
}

export interface taskItem {
  task_id: number
  task_name: string
  jump_url: string
  task_icon: string // 任务icon
  reward_icon: string // 奖励图标
  reward_type: rewardType
  reward_cnt: number
  task_need_cnt: number // 任务目标次数
  subtask_need_cnt: number // 任务目标次数
  task_cur_cnt: number // 任务累计次数
  subtask_cur_cnt: number // 任务累计次数
  task_complete_cnt: number // 任务完成次数
}

export interface InitialStateType {
  mid?: number
  free_card_cnt?: number // 剩余卡片数量
  signin_cnt?: number // 签到次数
  today_signin?: boolean // 判断今日是否签到
  signin_rewards?: Array<sign_reward> // 签到奖励
  daily_tasks?: Array<taskItem>
  novice_tasks?: Array<taskItem>

  week_cards?: {
    coins: number // 当天签到可获得的金币
    is_sign_in: SignInEnum // 0未签到 1 已签到 2 过期未签到
    day: number // 第几天
  }[]
  coins?: number // 用户金币数
  week_card_status?: number // 0: 没买周卡, 1: 买了周卡
  week_card_dollar?: string // 周卡花费数
  week_card_coin_total?: number // 周卡金币数
  week_card_coin_total_dollar?: string // 周卡价值数

  week_card_coin_left?: number // 周卡剩余金币数
  week_card_coin_get?: number // 周卡领取金币数
  week_card_coin_get_dollar?: string // 周卡领取价值数

  week_card_product_id?: string
  week_card_day?: number // 今天是周卡第几天,从1开始
  reward_page_url?: string // 激励页url
  notice_switch?: boolean // 是否预约push
}

const initialState: InitialStateType = {
  mid: 0,
  free_card_cnt: 0,
  signin_cnt: 0,
  today_signin: false,
  signin_rewards: [],
  daily_tasks: [],
}
export const ManPowerSlice = createSlice({
  name: 'ManPower',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(maleReward.fulfilled, (state, action) => {
      Object.assign(state, action.payload.data)
    })
  },
})

export default ManPowerSlice.reducer
